module.exports = __webpack_public_path__ + "img/bb_g3_mouth-01.18261f27.svg";